export default [
  {
    title: 'تنظیمات عمومی',
    icon: 'bx bxs-dashboard',
    children: [
      {
        title: 'اسلایدرهای محصول',
        route: { name: 'productslider' },
        resource: 'ProductSliderManager',
        action: 'show',
      },
      {
        title: 'بنرها',
        route: { name: 'banner' },
        resource: 'BannerManager',
        action: 'show',
      },
      {
        title: 'منو',
        route: { name: 'menu' },
        resource: 'MenuManager',
        action: 'show',
      },

      // {
      //   title: 'سوالات متداول',
      //   route: { name: 'faq' },
      //   resource: 'FaqManager',
      //   action: 'show',
      // },
      // {
      //   title: 'دسته بندی سوال',
      //   route: { name: 'faqcategory' },
      //   resource: 'FaqManager',
      //   action: 'show',
      // },
      // {
      //   title: 'بیماری ها',
      //   route: { name: 'sickness' },
      //   resource: 'SicknessManager',
      //   action: 'show',
      // },
      // {
      //   title: 'دسته بندی بیماری',
      //   route: { name: 'sicknesscategory' },
      //   resource: 'SicknessManager',
      //   action: 'show',
      // },
      // {
      //   title: 'لینک ها',
      //   route: { name: 'shorturl' },
      //   resource: 'ShortUrlManager',
      //   action: 'show',
      // },
      // {
      //   title: 'محتواها',
      //   route: { name: 'content' },
      //   resource: 'ContentManager',
      //   action: 'show',
      // },
      // {
      //   title: 'ورژن ها',
      //   route: { name: 'version' },
      //   resource: 'VersionManager',
      //   action: 'show',
      // },
      // {
      //   title: 'نظرهای مشتریان',
      //   route: { name: 'opinion' },
      //   resource: 'OpinionManager',
      //   action: 'show',
      // },
    ],
  },
]
